import React from "react";
import { useTranslation } from 'react-i18next';
import { Nav, Navbar, NavDropdown, NavLink } from 'react-bootstrap';
import { longLogoSrc } from "../../constants/constants";
import UserNavProfile from './UserNavProfile';

import './navigationbar.scss';
import AuthService from "../../services/AuthService";

const Navigationbar = () => {
  const { t } = useTranslation();

  const auth = AuthService.isLoggedIn();
  const authRender = () => {
    return (
      <Navbar expand="lg">
        <Navbar.Toggle className="navigationbar-item" ><svg
    xmlns="http://www.w3.org/2000/svg"
    width={35}
    height={45}
    fill="white"
    viewBox="0 0 1024 1024"
  >
    <path
      id="SVGRepo_iconCarrier"
      d="M64 192h896v76.8H64zm0 281.6h896v76.8H64zm0 281.6h896V832H64z"
    ></path>
  </svg></Navbar.Toggle>
        <Navbar.Brand href="/">
          <img className="navigationbar-logo" src={'/logo-sinfra-2025-white.svg'} />
        </Navbar.Brand>
        <Nav className="justify-content-end show-on-mobile">
          <UserNavProfile />
        </Nav>
        <Navbar.Collapse className="navigationbar-item ml-auto">
          <Nav className="mr-auto">
            {/* Add a link to the new "Create Email Template" page */}
            <NavLink href="/review-suppliers">
              LEVERANTÖRER
            </NavLink>
            <NavLink href="/follow-up">
              UPPFÖLJNING
            </NavLink>
            <NavLink href="/email-templates">
              EPOST MALLAR
            </NavLink>
          </Nav>
        </Navbar.Collapse>
        <Nav className="justify-content-end hide-on-mobile">
          <UserNavProfile />
        </Nav>
      </Navbar>
    );
  }

  const nonAuthRender = () => {
    return (
      <Navbar expand="lg">
        <Navbar.Brand href="/">
          <img className="navigationbar-logo" src={longLogoSrc} />
        </Navbar.Brand>
      </Navbar>
    );
  }

  return (
    <div className="navigationbar-root">
      {(auth)? authRender() : nonAuthRender()}
    </div>
  );
};

export default Navigationbar;
